import React, { useEffect } from 'react';
import Layout from '../Layout/Layout';
import { useSelector } from 'react-redux';
import { useJunoCommonFunctions } from '../../client/Juno/helpers';
import JunoClientSnackbar from '../../client/Juno/client/components/global/JunoClientSnackbar';
import { fiatTransactions } from '../helpers/constant';
import BalancesSection from '../components/overview/BalancesSection';

export default function BalancesPage() {
    const { getBalances, getSavedAccounts, getManagedCurrencies } = useJunoCommonFunctions();
    const clientData = useSelector(state => state.juno.clientData);
    const { managedCurrencies, balancesCurrencies } = useSelector(state => state.juno);

    useEffect(() => {
        if (clientData) {
            getBalances();
            getManagedCurrencies();
        }
    }, [clientData]);

    useEffect(() => {
        getSavedAccounts();
    }, []);

    return (
        <div className="h-full">
            <div className="rounded-xl lg:pt-[2px]">
                <BalancesSection
                    managedCurrencies={managedCurrencies}
                    balancesData={balancesCurrencies}
                    actionIcons={fiatTransactions}
                    isDashboard={false}
                />
                <JunoClientSnackbar />
            </div>
        </div>
    );
}
